import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function LegajosMasivosForm() {
  const [dniText, setDniText] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dniText.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Ingrese al menos un DNI",
      });
      return;
    }

    Swal.fire({
      title: "Generando legajos...",
      html: "Por favor, espere mientras se procesan los DNIs.",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const cadetes = dniText
        .split("\n")
        .map((dni) => dni.trim())
        .filter((dni) => dni)
        .map((cadeteDni) => ({ cadeteDni }));

      const body = { cadetes };

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/legajosMasivos",
        body,
        {/*
          headers: { Authorization: "Basic " + btoa("password:tuPassword") },
     */   }
      );

      const { zip, dnisNoEncontrados } = response.data;

      Swal.close();

      // 1️⃣ Descargar ZIP si existe
      if (zip) {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, "0");
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const year = today.getFullYear();
        const fechaHoy = `${day}-${month}-${year}`;

        const blob = new Blob([Uint8Array.from(atob(zip), (c) => c.charCodeAt(0))], {
          type: "application/zip",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `legajos-${fechaHoy}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      // 2️⃣ Mostrar DNIs no encontrados si los hay
      if (dnisNoEncontrados && dnisNoEncontrados.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "DNIs no encontrados",
          html: `No se encontraron los siguientes DNIs:<br>${dnisNoEncontrados.join(", ")}`,
        });
      } else if (zip) {
        // 3️⃣ Mostrar éxito si se descargó algo y todos se encontraron
        Swal.fire({
          icon: "success",
          title: "Legajos generados",
          text: "La descarga se completó correctamente.",
        });
      } else {
        // 4️⃣ Si no hay ZIP ni DNIs no encontrados
        Swal.fire({
          icon: "info",
          title: "Sin legajos",
          text: "No se generó ningún legajo.",
        });
      }

    } catch (error) {
      console.error(error);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un problema al generar los legajos.",
      });
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ maxWidth: "400px", margin: "20px auto" }}
    >
      <textarea
        rows={10}
        placeholder="Ingrese un DNI por línea"
        value={dniText}
        onChange={(e) => setDniText(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      />
      <button
        type="submit"
        className="btn btn-success"
        style={{ width: "100%", padding: "8px" }}
      >
        Generar Legajos
      </button>
    </form>
  );
}
